import React from 'react'
import AccessOpeningState from './AccessOpeningContext/AccessOpeningState'
import InstanceState from './InstanceContext/InstanceState'
import LoginState from './LoginContext/LoginState'
import DashboardState from './DashboardContext/DashboardState'
import AccessEgressContext from './AccessEgressContext'
import FiltersContext from './FiltersContext'
import ReportsContext from './ReportsContext'
import ConfigContext from './ConfigContext'
import AccessBuildingState from './AccessBuildingContext/AccessBuildingState'

const StateContext = ({ children }) => {
    return (
        <InstanceState>
            <LoginState>
                <AccessOpeningState>
                    <AccessBuildingState>
                        <AccessEgressContext>
                            <FiltersContext>
                                <DashboardState>
                                    <ReportsContext>
                                        <ConfigContext>
                                            {children}
                                        </ConfigContext>
                                    </ReportsContext>
                                </DashboardState>
                            </FiltersContext>
                        </AccessEgressContext>
                    </AccessBuildingState>
                </AccessOpeningState>
            </LoginState>
        </InstanceState>
    )
}

export default StateContext